import {
  ADD_RATING_FAIL,
  ADD_RATING_SUCCESS,
  ADD_TEAM_MEMBER_FAIL,
  ADD_TEAM_MEMBER_REQUEST,
  ADD_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_FAIL,
  DELETE_TEAM_MEMBER_REQUEST,
  DELETE_TEAM_MEMBER_RESET,
  DELETE_TEAM_MEMBER_SUCCESS,
  GET_ALL_VALET_TEAMS_FAIL,
  GET_ALL_VALET_TEAMS_REQUEST,
  GET_ALL_VALET_TEAMS_SUCCESS,
  GET_VALET_TEAMS_FAIL,
  GET_VALET_TEAMS_REQUEST,
  GET_VALET_TEAMS_SUCCESS,
  MAID_CREATE_FAIL,
  MAID_CREATE_REQUEST,
  MAID_CREATE_SUCCESS,
  MAID_DELETE_FAIL,
  MAID_DELETE_REQUEST,
  MAID_DELETE_SUCCESS,
  MAID_GET_ALL_FAIL,
  MAID_GET_ALL_REQUEST,
  MAID_GET_ALL_SUCCESS,
  MAID_GET_EARNINGS_FAIL,
  MAID_GET_EARNINGS_REQUEST,
  MAID_GET_EARNINGS_SUCCESS,
  MAID_UPDATE_FAIL,
  MAID_UPDATE_REQUEST,
  MAID_UPDATE_SUCCESS,
  PAY_MAID_FAIL,
  PAY_MAID_REQUEST,
  PAY_MAID_SUCCESS,
  STAFF_GET_ALL_FAIL,
  STAFF_GET_ALL_REQUEST,
  STAFF_GET_ALL_SUCCESS,
  TIP_ADD_FAIL,
  TIP_ADD_REQUEST,
  TIP_ADD_SUCCESS,
  VALET_TEAM_CREATE_FAIL,
  VALET_TEAM_CREATE_REQUEST,
  VALET_TEAM_CREATE_SUCCESS,
  VERIFY_BULK_TEAMS_FAIL,
  VERIFY_BULK_TEAMS_REQUEST,
  VERIFY_BULK_TEAMS_SUCCESS,
  VERIFY_PAYMENT_FAIL,
  VERIFY_PAYMENT_REQUEST,
  VERIFY_PAYMENT_SUCCESS,
} from "../Constants/maidConstants";
import api, { unwrapData } from "../service/api";
import axios from "axios";
import { BACKEND_URL } from "../../config.js";

const getMessage = (error, fallback = "Request failed") =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error.message ||
  fallback;

export const getAllMaids = (hotelId, type) => async (dispatch) => {
  try {
    dispatch({ type: MAID_GET_ALL_REQUEST });

    const payload = { hotelId };
    if (type) payload.type = type;

    const { data } = await api.post("api/maids/get", payload);

    dispatch({
      type: MAID_GET_ALL_SUCCESS,
      payload: unwrapData(data, "maids"),
      meta: { maidType: type },
    });
  } catch (error) {
    dispatch({ type: MAID_GET_ALL_FAIL, payload: getMessage(error) });
  }
};

export const getAllStaff = () => async (dispatch) => {
  try {
    dispatch({ type: STAFF_GET_ALL_REQUEST });
    const { data } = await api.get("api/maids/getAllStaff");
    dispatch({
      type: STAFF_GET_ALL_SUCCESS,
      payload: unwrapData(data, "maids", "staff"),
    });
  } catch (error) {
    dispatch({ type: STAFF_GET_ALL_FAIL, payload: getMessage(error) });
  }
};

export const createMaid = (maidData) => async (dispatch) => {
  try {
    dispatch({ type: MAID_CREATE_REQUEST });
    const { data } = await api.post("api/maids", maidData);
    dispatch({ type: MAID_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MAID_CREATE_FAIL, payload: getMessage(error) });
  }
};

export const deleteMaid = (maidId, maidType) => async (dispatch) => {
  try {
    dispatch({ type: MAID_DELETE_REQUEST });
    await api.delete(`api/maids/${maidId}`);

    dispatch({
      type: MAID_DELETE_SUCCESS,
      payload: { _id: maidId, type: maidType },
    });
  } catch (error) {
    dispatch({ type: MAID_DELETE_FAIL, payload: getMessage(error) });
  }
};

export const updateMaid = (maidData) => async (dispatch) => {
  try {
    dispatch({ type: MAID_UPDATE_REQUEST });
    const { data } = await api.put("api/maids/update", maidData);
    dispatch({ type: MAID_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MAID_UPDATE_FAIL, payload: getMessage(error) });
  }
};

export const addTip =
  (id, account, paymentId, amount, review) => async (dispatch) => {
    try {
      dispatch({ type: TIP_ADD_REQUEST });
      const { data } = await axios.post(
        `${BACKEND_URL}api/maids/${id}/addTip`,
        { account, paymentId, amount, review },
        {
          headers: {
            "Content-type": "application/json",
          },
        },
      );
      dispatch({ type: TIP_ADD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: TIP_ADD_FAIL, payload: getMessage(error) });
    }
  };

export const getMaidEarnings =
  (hotelId, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: MAID_GET_EARNINGS_REQUEST });

      const { data } = await api.get(
        `api/maids/earnings?hotelId=${hotelId}&startDate=${startDate}&endDate=${endDate}`,
      );
      dispatch({ type: MAID_GET_EARNINGS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: MAID_GET_EARNINGS_FAIL, payload: getMessage(error) });
    }
  };

export const payMaid =
  ({ sessionInfo, token, idempotencyKey }) =>
  async (dispatch) => {
    try {
      dispatch({ type: PAY_MAID_REQUEST });
      const response = await axios.post(
        `${BACKEND_URL}payment/payMaid`,
        {
          sessionInfo,
          token,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Idempotency-Key": idempotencyKey,
          },
        },
      );
      if (response.data.success) {
        dispatch({ type: PAY_MAID_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: PAY_MAID_FAIL, payload: response.data.message });
      }
    } catch (error) {
      dispatch({
        type: PAY_MAID_FAIL,
        payload: error.response ? error.response.data.error : error.message,
      });
    }
  };

export const addRating =
  (maid, rating, paymentIntentId) => async (dispatch) => {
    try {
      const response = await api.post("api/maids/ratings", {
        rating,
        maid,
        paymentIntentId,
      });
      dispatch({ type: ADD_RATING_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: ADD_RATING_FAIL, payload: getMessage(error) });
    }
  };

export const createValetTeam =
  (
    hotel,
    location,
    startDate,
    endDate,
    tip,
    review,
    teamMembers,
    paymentIntentId,
    customer,
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: VALET_TEAM_CREATE_REQUEST });
      const { data } = await api.post("api/maids/valet-teams", {
        hotel,
        location,
        startDate,
        endDate,
        tip,
        review,
        teamMembers,
        paymentIntentId,
        customer,
      });

      dispatch({ type: VALET_TEAM_CREATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: VALET_TEAM_CREATE_FAIL, payload: getMessage(error) });
    }
  };

export const getAllValetTeams = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_VALET_TEAMS_REQUEST });

    const { data } = await api.get("api/maids/valet-teams-all");

    dispatch({
      type: GET_ALL_VALET_TEAMS_SUCCESS,
      payload: unwrapData(data, "valetTeams"),
    });
  } catch (error) {
    dispatch({ type: GET_ALL_VALET_TEAMS_FAIL, payload: getMessage(error) });
  }
};

export const getValetTeams =
  ({ hotelId, service, page = 1, limit = 15, verified }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_VALET_TEAMS_REQUEST });

      const { data } = await api.post("api/maids/valet-teams/paginated", {
        hotelId,
        service,
        page,
        limit,
        verified,
      });

      dispatch({ type: GET_VALET_TEAMS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_VALET_TEAMS_FAIL, payload: getMessage(error) });
    }
  };

export const addTeamMember =
  (valetTeamId, teamMemberData) => async (dispatch) => {
    try {
      dispatch({ type: ADD_TEAM_MEMBER_REQUEST });
      const { data } = await api.post("api/maids/add-member", {
        valetTeamId,
        teamMemberData,
      });
      dispatch({ type: ADD_TEAM_MEMBER_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: ADD_TEAM_MEMBER_FAIL, payload: getMessage(error) });
    }
  };

export const deleteTeamMember = (valetTeamId, memberId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_TEAM_MEMBER_REQUEST });
    const { data } = await api.delete(
      `api/maids/${valetTeamId}/member/${memberId}`,
    );
    dispatch({ type: DELETE_TEAM_MEMBER_SUCCESS, payload: data.team });
    dispatch({ type: DELETE_TEAM_MEMBER_RESET });
  } catch (error) {
    dispatch({ type: DELETE_TEAM_MEMBER_FAIL, payload: getMessage(error) });
  }
};

export const verifyPayment =
  (
    hotelId,
    teamId,
    teamMembers,
    tipAmountPerMember,
    review,
    parentTransactionId,
    customer,
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: VERIFY_PAYMENT_REQUEST });
      const { data } = await axios.post(`${BACKEND_URL}payment/payTeam`, {
        hotelId,
        teamId,
        teamMembers,
        tipAmountPerMember,
        review,
        parentTransactionId,
        customer,
      });
      if (!data.success) return;
      dispatch({
        type: VERIFY_PAYMENT_SUCCESS,
        payload: {
          success: data.success,
          payouts: data.payouts,
        },
      });
      return data;
    } catch (error) {
      dispatch({
        type: VERIFY_PAYMENT_FAIL,
        payload: error.response?.data.message || "Payment verification failed",
      });
    }
  };

export const verifyBulkTeams = (payload) => async (dispatch) => {
  try {
    dispatch({ type: VERIFY_BULK_TEAMS_REQUEST });

    const { data } = await axios.post(
      `${BACKEND_URL}payment/payTeam-bulk`,
      payload,
    );

    if (!data.success) {
      throw new Error(data.message || "Bulk verification failed");
    }

    dispatch({
      type: VERIFY_BULK_TEAMS_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    dispatch({
      type: VERIFY_BULK_TEAMS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
